define('TavanoTeamStaging.MadeToOrder.Shopping.AddedToCart.View', [
  'tavanoteamstaging_madetoorder_addedtocart.tpl',
  'Backbone',
  'underscore'
], function(
  tavanoteamstaging_madetoorder_addedtocart_tpl,
  Backbone,
  _
) {
  'use strict';

  return Backbone.View.extend({
    template: tavanoteamstaging_madetoorder_addedtocart_tpl,

    initialize: function(options) {
      this.container = options.container;
      this.environment = this.container.getComponent("Environment");
      this.disclaimerMessage = options.disclaimerMessage;
      this.showDisclaimerMessage = (options.itemInfo && options.itemInfo.item.custitem_tt_made_to_order === true && !_.isEmpty(this.disclaimerMessage));
    },

    getContext: function() {
      return {
        showDisclaimerMessage: this.showDisclaimerMessage,
        disclaimerMessage: this.disclaimerMessage
      };
    }
  });
});
